// src/components/PageLayout.jsx
import React from 'react';
import { Spinner, ErrorPage } from './common';

export default function PageLayout({ loading, error, onRetry, children }) {
  if (loading) {
    return (
      <div style={styles.centerContainer}>
        <Spinner />
      </div>
    );
  }

  if (error) {
    // Если error - это объект из нашего хука
    if (typeof error === 'object' && error !== null && error.code) {
      return (
        <ErrorPage
          code={error.code}
          message={error.message} // Будет null, и ErrorPage покажет дефолтный текст
          onRetry={onRetry}
        />
      );
    }

    // Фоллбэк для старого кода (если вдруг error - строка)
    return (
      <ErrorPage
        code="500"
        message={typeof error === 'string' ? error : null}
        onRetry={onRetry}
      />
    );
  }

  return <>{children}</>;
}

const styles = {
  centerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '400px',
  },
};
